/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "jcaportalweb",
            "endpoint": "https://5ojkrm1zmb.execute-api.us-east-1.amazonaws.com/test",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:2ebd2e19-b74b-434a-9570-9d0788593bb0",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_O1Fq8bUZN",
    "aws_user_pools_web_client_id": "1sbc97pli5g6g1r6vc1ehlko39",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "jcaportalweb-test",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dcq2worsggvj3.cloudfront.net",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "AuditTrails-test",
            "region": "us-east-1"
        },
        {
            "tableName": "ConnectionEvents-test",
            "region": "us-east-1"
        },
        {
            "tableName": "PublicKeys-test",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
